import React from 'react';
import { AuthLayout } from '../../../components/layout/Layouts'; 
import StaffOnboard from '../../../components/Dashboard/StaffOnboard'

const StaffOnboardPage = () => {
  return (
    <AuthLayout>
      <StaffOnboard />
    </AuthLayout>
  );
};

export default StaffOnboardPage;
